import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getPersonaStatus,
  setPersonaStatus,
} from "../../helper/Controllers/StatusController";
import { readFromFBDB, updateValueInFBDB } from "../../services/fbdb.data";
import { selectLogInUsername, SelectUserAccountInfo, setCheckoutLabel } from "../../common/authenticateDashboard/authSlice";
import { ref, set } from "firebase/database";
import { db } from "../../firebase";
import handleToast from "../../helper/Toast";
import { ToastContainer } from "react-toastify";
import { getDataFromMongoDb, updateDataInMongoDb } from "../../services/mongod.data";

const API_ENDPOINT =
  "https://us-central1-causalfunnel-21.cloudfunctions.net/CFDashboardUpdateWebhook";

const Settings = () => {
  const [enable, setEnable] = useState(true);
  const [email, setEmail] = useState("");
  const [progress, setProgress] = useState(0);
  const [updateLimitReached, setUpdateLimitReached] = useState(false);
  const [updateHistory, setUpdateHistory] = useState([]);
  const sessionUser = useSelector(selectLogInUsername);
  const user = sessionUser?.split("@")[0];
  const [currentUpdates, setCurrentUpdates] = useState(0);
  const [loading, setLoading] = useState(false); // Add loading state
  const UserAccountInfo = useSelector(SelectUserAccountInfo);
  console.log("UserAccountInfo", UserAccountInfo);
  const dispatch = useDispatch();

  const handlePersonaStatusChange = async (status) => {
    try {
      await setPersonaStatus(status);
    } catch {
      console.error("Error in handlePersonaStatusChange");
    }
  };

  useEffect(() => {
    handlePersonaStatusChange(enable);
  }, [enable]);

  useEffect(() => {
    const fetchPersonaStatus = async () => {
      try {
        const result = await getPersonaStatus();
        // console.log("result", result);
        // setPaidStatus(result);
      } catch {
        console.error("Error in fetchPersonaStatus");
      }
    };

    fetchPersonaStatus();

    const getCookie = (name) => {
      const cookies = document.cookie.split("; ");
      for (const cookie of cookies) {
        const [cookieName, cookieValue] = cookie.split("=");
        if (cookieName === name) {
          return cookieValue;
        }
      }
      return null;
    };

    const emailValue = getCookie("user");
    setEmail(emailValue);
  }, []);

  const getUnixTime = (date) => Math.floor(date.getTime() / 1000);

  const getMonday = (d) => {
    d = new Date(d);
    const day = d.getDay(),
      diff = d.getDate() - day + (day === 0 ? -6 : 1); // Adjust if Sunday
    return new Date(d.setDate(diff));
  };

  useEffect(() => {
    const checkProgress = async () => {
      const currentDate = new Date();
      const monday = getMonday(currentDate);
      const year = monday.getFullYear().toString();
      const month = (monday.getMonth() + 1).toString().padStart(2, "0");
      const date = monday.getDate().toString().padStart(2, "0");
      // const weekSubpath = `${user}/graph-dashboard-update/${year}/${month}/${date}`;

      try {
        // const weeklyResult = await readFromFBDB(weekSubpath);
        const weeklyDataMongo = await getDataFromMongoDb(user, "graph-dashboard-update");
        const weekData = weeklyDataMongo.data.year.month.date || [];
        const weekDataLength = weekData.length;
        const weekLastUpdateData = weekData[weekDataLength - 1];

        // console.log("weekdata", weeklyDataMongo);

        if (weekLastUpdateData) {
          const givenTimestamp = parseInt(weekLastUpdateData.timestamp, 10);
          const startDateTime = givenTimestamp;
          const endDateTime = startDateTime + 6 * 60 * 60;
          const currentDateTime = Math.floor(Date.now() / 1000);

          // console.log("currentDateTime", currentDateTime, startDateTime);
          // console.log("endDateTime", endDateTime);

          if (currentDateTime >= startDateTime && currentDateTime <= endDateTime) {
            setUpdateLimitReached(true);
            // console.log("setting updateLimitReached", true);
          } else {
            setUpdateLimitReached(false);
            // console.log("setting updateLimitReached", false);
          }
        }

        setCurrentUpdates(weekDataLength);

        // const monthSubpath = `${user}/graph-dashboard-update/${year}/${month}`;
        // const monthlyResult = await readFromFBDB(monthSubpath);
        const monthData = await getDataFromMongoDb(user, "graph-dashboard-update");
        const monthlyResult = monthData[year][month];
        // console.log("monthlyResult", monthlyResult);
        

        if (monthlyResult.data) {
          const history = Object.values(monthlyResult.data).flat();
          history.sort((a, b) => {
            const dateA = new Date(a.date);
            const dateB = new Date(b.date);

            if (dateA > dateB) return -1;
            if (dateA < dateB) return 1;

            const timestampA = parseInt(a.timestamp, 10);
            const timestampB = parseInt(b.timestamp, 10);

            return timestampB - timestampA; // For descending order
          });

          setUpdateHistory(history);
        } else {
          setUpdateHistory([]);
        }
      } catch (error) {
        console.error("Error checking progress:", error.message);
        setProgress(0);
        setUpdateLimitReached(false);
        setUpdateHistory([]);
      }
    };

    if (enable) {
      checkProgress();
    }
  }, [user, enable]);

  const makeApiCall = async (shopName, startDate, endDate) => {
    const fields = {
      shop_name: shopName,
      start_date: startDate,
      end_date: endDate,
    };

    try {
      const response = await fetch(API_ENDPOINT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(fields),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      // console.log("Success:", data);
    } catch (error) {
      console.error("Error making the API call:", error);
    }
  };

  const updateProgress = async () => {
    console.log(updateLimitReached);

    if (updateLimitReached) {
      handleToast("error", "Update limit for the week has been reached.");
      return;
    }

    setLoading(true); // Start loading spinner

    const currentDate = new Date();
    const monday = getMonday(currentDate);
    const clientName = user.replace("-prod", "");
    const formatYmd = (date) => date.toISOString().slice(0, 10).replace(/-/g, "");
    const startDate = formatYmd(monday);
    const endDate = formatYmd(currentDate);

    try {
      const year = monday.getFullYear().toString();
      const month = (monday.getMonth() + 1).toString().padStart(2, "0");
      const date = monday.getDate().toString().padStart(2, "0");
      const weekSubpath = `${user}/graph-dashboard-update/${year}/${month}/${date}`;
      await makeApiCall(clientName, startDate, endDate);
      // const weekData = await readFromFBDB(weekSubpath)
      const weeklyDataMongo = await getDataFromMongoDb(user, "graph-dashboard-update");
      const weekData = weeklyDataMongo.data.year.month.date || [];
      // .then((result) => result.data || [])
      // .catch(() => []);

      const givenTimestamp = Math.floor(Date.now() / 1000);
      const startDateTime = givenTimestamp - 60 * 60;
      const endDateTime = givenTimestamp + 6 * 60 * 60;
      const currentDateTime = Math.floor(Date.now() / 1000);

      const startDateTimeString = new Date(startDateTime * 1000).toLocaleString();
      const endDateTimeString = new Date(endDateTime * 1000).toLocaleString();
      const currentDateTimeString = new Date(currentDateTime * 1000).toLocaleString();

      // console.log("Start DateTime:", startDateTimeString);
      // console.log("End DateTime:", endDateTimeString);
      // console.log("Current DateTime:", currentDateTimeString);

      if (currentDateTime > startDateTime && currentDateTime < endDateTime) {
        console.log(true);
        setUpdateLimitReached(true);
        // console.log("setting updateLimitReached", true);
      } else {
        console.log(false);
        setUpdateLimitReached(false);
        // console.log("setting updateLimitReached", false);
      }

      const newEntry = {
        timestamp: getUnixTime(currentDate).toString(),
        date: currentDate.toISOString().split("T")[0],
      };

      weekData.push(newEntry);

      await set(ref(db, weekSubpath), weekData);

      setCurrentUpdates(weekData.length);
      setUpdateHistory([...updateHistory, newEntry]);
      handleToast("success", "Updated Successfully!");
    } catch (error) {
      handleToast("error", "Try again later!");
      console.error("Error updating data:", error.message);
    } finally {
      setLoading(false); // Stop loading spinner
    }
  };

  const handleCheckoutMode = async (mode) => { 
    if (mode === "book_now") { 
      // await updateValueInFBDB(`${user}/graph-account-info/checkoutLabel`, "Book Now Button");
      await updateDataInMongoDb(user, "graph-account-info",["checkoutLabel"], "Book Now Button");
      handleToast("success", "Checkout mode set to Book Now");
      // setCheckoutLabel
      dispatch(setCheckoutLabel("Book Now Button"));
    }
    else if (mode === "add_to_cart") {
      // await updateValueInFBDB(`${user}/graph-account-info/checkoutLabel`, "Add To Cart Button");
      await updateDataInMongoDb(user, "graph-account-info",["checkoutLabel"], "Add To Cart Button");  
      handleToast("success", "Checkout mode set to Add To Cart");
      dispatch(setCheckoutLabel("Add To Cart Button"));

    }
    else {
      handleToast("error", "Invalid checkout mode selected");
    }
  }

  return (
    <div className="w-[75%] flex-grow m-3">
      <ToastContainer />
      {loading ?<div className="loader flex-grow flex justify-center items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="185px" height="185px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                            <circle cx="50" cy="50" r="0" fill="none" stroke="#b927d4" strokeWidth="1">
                                <animate attributeName="r" repeatCount="indefinite" dur="1.2658227848101264s" values="0;51" keyTimes="0;1" keySplines="0 0.2 0.8 1" calcMode="spline" begin="0s"></animate>
                                <animate attributeName="opacity" repeatCount="indefinite" dur="1.2658227848101264s" values="1;0" keyTimes="0;1" keySplines="0.2 0 0.8 1" calcMode="spline" begin="0s"></animate>
                            </circle><circle cx="50" cy="50" r="0" fill="none" stroke="#32c5ff" strokeWidth="1">
                                <animate attributeName="r" repeatCount="indefinite" dur="1.2658227848101264s" values="0;51" keyTimes="0;1" keySplines="0 0.2 0.8 1" calcMode="spline" begin="-0.6329113924050632s"></animate>
                                <animate attributeName="opacity" repeatCount="indefinite" dur="1.2658227848101264s" values="1;0" keyTimes="0;1" keySplines="0.2 0 0.8 1" calcMode="spline" begin="-0.6329113924050632s"></animate>
                            </circle>
                        </svg>
                    </div> :
      
      <>
      <div className="bg-white flex-grow text-2xl text-gray-400 font-[700] mb-3">
        Settings
      </div>
      <div className="mb-2 rounded-md border-2">
        <div className="pl-3 bg-gray-300 py-2">Settings</div>
        <div className="grid grid-cols-3 p-2">
          <div className="col-span-1">
            <p className="pl-3 p-1 font-semibold">Username</p>
            {/* <p className="pl-3 p-1 font-semibold">Persona Nudge</p> */}
            <p className="pl-3 p-1 font-semibold">Checkout Mode</p>
            <p className="pl-3 p-1 font-semibold">Dashboard Update</p>
          </div>
          <div className="col-span-2">
            <p className="pl-3 p-1 text-lg">{email}</p>

            {/* <p>
              <span className="mr-2 text-lg">
                {enable !== true ? "Disabled" : "Enabled"}
              </span>
              <button
                type="button"
                className="rounded-md bg-[#343A40] px-2.5 py-1 text-sm font-semibold text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                onClick={() => setEnable((prev) => !prev)}
              >
                {enable === true ? "Disable" : "Enable"}
              </button>
                </p> */}

            <p className="flex gap-2 items-center my-2">
              <button
                onClick={() => handleCheckoutMode("book_now")}
                className={
                  !UserAccountInfo?.checkoutLabel || UserAccountInfo?.checkoutLabel?.includes("Book Now")
                    ? "bg-emerald-600 text-white px-2 py-1 rounded"
                    : " text-gray-700 px-2 py-1 rounded hover:bg-gray-300 transition"
                }
              >
                Book Now
              </button>
              <button
                onClick={() => handleCheckoutMode("add_to_cart")}
                className={
                  UserAccountInfo?.checkoutLabel?.includes("Add To Cart")
                    ? "bg-emerald-600 text-white px-2 py-1 rounded"
                    : " text-gray-700 px-2 py-1 rounded hover:bg-gray-300 transition"
                }
              >
                Add To Cart
              </button>
            </p>

            <div className="flex items-center my-4">
              <div className="w-1/2 bg-white-200 rounded-full h-2.5 dark:bg-gray-700">
                {/* <div
                  className="bg-blue-600 h-2.5 rounded-full"
                  style={{ width: `${progress}%` }}
                ></div> */}
              </div>
              {/* <span className="ml-3">{`(${currentUpdates}/3)`}</span> */}
            </div>

            <button
              disabled={updateLimitReached || loading} // Disable button when loading
              className={`inline ${updateLimitReached || loading
                ? "bg-gray-500"
                : "bg-blue-500 hover:bg-blue-700"
                } text-white font-bold py-2 px-4 rounded`}
              onClick={updateProgress}
            >
              Update {/* Show spinner when loading */}
            </button>
            {updateLimitReached && (
              <span className="ml-3 text-red-500">
                You've reached the maximum update limit for this 6-hour period.
              </span>
            )}
          </div>
        </div>
      </div>

      <div className="mt-5">
        <h2 className="text-xl font-semibold mb-3">Dashboard update history (weekly)</h2>
        {updateHistory.length > 0 ? (
          <table className="min-w-full leading-normal">
            <thead>
              <tr>
                <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-sm font-semibold text-gray-600 uppercase tracking-wider">
                  Date
                </th>
                <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-sm font-semibold text-gray-600 uppercase tracking-wider">
                  Timestamp
                </th>
              </tr>
            </thead>
            <tbody>
              {updateHistory.map((item, index) => (
                <tr key={index}>
                  <td className="px-3 py-3 border-b border-gray-200 bg-white text-sm">
                    {item.date}
                  </td>
                  <td className="px-3 py-3 border-b border-gray-200 bg-white text-sm">
                    {new Date(item.timestamp * 1000).toLocaleString()}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p>No update history found.</p>
        )}
      </div>
        </>}
      
    </div>
  );
};

export default Settings;